import React from 'react'

class KeyMonitor extends React.Component{

  shouldComponentUpdate(){
    return(false)
  }
  componentDidMount(){
    let props = this.props
    window.onkeydown = function (e) {
      let code = e.keyCode ? e.keyCode : e.which;
      if (code === 68) {
        if(props.debugChangeHandler){ props.debugChangeHandler() }
      } else if (code === 76) {
        if(props.letterboxChangeHandler){ props.letterboxChangeHandler() }
      }
    };
  }

  render(){
    return(null)
  }
}

export default KeyMonitor



// WEBPACK FOOTER //
// ./src/KeyMonitor.js